$(function () {
    const input_postcode_instance_nav = document.querySelector('#instance-navigation-data #postcode')
    const input_postcode_contact_5 = document.querySelector('#contact5__form input[name=postcode]')

    // @init -----------------------------------------------------------------------------------------------------------
    if (input_postcode_contact_5) {
        if (input_postcode_contact_5.value.length === 0) {
            input_postcode_contact_5.value = input_postcode_instance_nav.value
        }
    }

    // @event listeners ------------------------------------------------------------------------------------------------
    $(document).on('click', '#js-contact5__show-form', function () {
        $('.contact5__section').removeClass('contact5__section--state-1').addClass('contact5__section--state-2')
    })

    $(document).on('click', '#js-contact5__hide-form', function (e) {
        e.preventDefault()
        $('#contact5__form').trigger('reset')
        $('.contact5__section').removeClass('contact5__section--state-2').addClass('contact5__section--state-1')
    })
})
